export const LESSON_SECTIONS = ["video", "vocabulary", "quiz", "ai_dialog"];

export const SECTION_STEP_MAP = {
  video: 1,
  vocabulary: 2,
  quiz: 3,
  ai_dialog: 4,
};

export const STEP_SECTION_MAP = {
  1: "video",
  2: "vocabulary",
  3: "quiz",
  4: "ai_dialog",
};

function isSectionCompleted(section) {
  if (!section) return false;
  if (typeof section === "string") {
    return section.toLowerCase() === "completed";
  }
  const status = (section.status || section.completion_status || "").toLowerCase();
  return status === "completed";
}

export function parseLessonProgress(data, lessonFallback = null) {
  const raw = data || {};
  const fallbackSections = lessonFallback?.section_progress || {};
  const sectionsSource = raw.section_progress || raw.sections || fallbackSections || {};

  const sections = {};
  LESSON_SECTIONS.forEach((key) => {
    const src = sectionsSource[key];
    const completed = isSectionCompleted(src);
    sections[key] = {
      status: completed ? "completed" : src?.status || "not_started",
      completed_at: src?.completed_at || null,
    };
  });

  let completedCount = LESSON_SECTIONS.filter((key) => sections[key].status === "completed").length;
  const allDone = completedCount === LESSON_SECTIONS.length;
  const rawStatus = (raw.completion_status || raw.status || "").toString().toUpperCase();

  const isCompleted = rawStatus === "COMPLETED" || raw.is_completed === true || (!rawStatus && allDone);

  if (isCompleted) {
    LESSON_SECTIONS.forEach((key) => {
      if (sections[key].status !== "completed") {
        sections[key] = { status: "completed", completed_at: sections[key].completed_at };
      }
    });
    completedCount = LESSON_SECTIONS.length;
  }

  let completion_status = rawStatus;
  if (!completion_status) {
    completion_status = isCompleted ? "COMPLETED" : completedCount > 0 ? "IN_PROGRESS" : "NOT_STARTED";
  }

  return {
    completion_status: isCompleted ? "COMPLETED" : completion_status,
    isCompleted,
    sections,
    completedCount,
    totalSections: LESSON_SECTIONS.length,
  };
}

export function getFirstIncompleteSection(progress) {
  return LESSON_SECTIONS.find((key) => progress?.sections?.[key]?.status !== "completed") || "video";
}
